import { render, staticRenderFns } from "./ComplaintInfoPreview.vue?vue&type=template&id=7ac5da62&scoped=true&"
import script from "./ComplaintInfoPreview.vue?vue&type=script&lang=js&"
export * from "./ComplaintInfoPreview.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintInfoPreview.vue?vue&type=style&index=0&id=7ac5da62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac5da62",
  null
  
)

export default component.exports